export const isImageFile = (file: File) => {
  if (!file) {
    return false;
  }

  const ext = file.type.slice(file.type.lastIndexOf('/') + 1);

  return '|jpg|png|jpeg|bmp|gif|'.includes(`|${ext}|`);
};
